import React from 'react'

function PdfViewer({ link }) {
  return <object className="pdf" data={link} width="100%" height="100%"></object>
}

function ImagesViewer({ links }) {
  return (
    <div className="dome-full-width dome-full-height dome-scrollable">
      {links.map((link, index) => (
        <img src={link} key={index} style={{ width: '100%' }} />
      ))}
    </div>
  )
}

export default function FormPreviewer({ title, pdfLink, pageLinks }) {
  return (
    <div className="request-questionnaire-pdf">
      {pdfLink ? (
        <PdfViewer link={pdfLink} />
      ) : pageLinks?.length > 0 ? (
        <ImagesViewer links={pageLinks} />
      ) : (
        <div className="request-questionnaire-pdf-body dome-d-flex dome-flex-column dome-align-center dome-gap24">
          <span className="dome-h3 dome-color-green-gradient dome-text-center">{title}</span>
          <i style={{ fontSize: '52px' }} className="fa-thin fa-clipboard-question dome-color-green-gradient"></i>
        </div>
      )}
    </div>
  )
}
